import { render, staticRenderFns } from "./casesPage.vue?vue&type=template&id=190a86eb&scoped=true"
import script from "./casesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./casesPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./casesPage.vue?vue&type=style&index=0&id=190a86eb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a86eb",
  null
  
)

export default component.exports